import axios from 'axios'
import { Message } from 'element-ui'
import vue from 'vue'
import configs from '../../static/lib/config'
import store from '@/store';

axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'

// request interceptor
axios.interceptors.request.use(
  	config => {
   		//config.url = configs.baseUrl + config.url
    	return config
  	},
  	error => {
    	// Do something with request error
    	// console.log(error) // for debug
    	Promise.reject(error)
  	}
)

// response interceptor
axios.interceptors.response.use(
  	response => {
  		return response.data;
  	},
  	error => {
    	// console.log('err' + error) // for debug
    	return Promise.reject(error)
  	}
)

export function doRequest(options) {
	let _this = this
    return axios(options).then(res => {
	    if (res.success === true) {
	        return res
	    }else {
			throw new Error(res.message)
	    }
    }).catch(error => {
        if (this && this.$message && error.message) {
            this.$message.error(error.message)
        }
        throw error
    })
}

vue.prototype.$doRequest = doRequest

export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js